var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-dark",attrs:{"id":"app"}},[_c('TopMenu'),_c('iframe',{staticStyle:{"width":"100%","height":"100vh","border":"none"},attrs:{"src":"/static/news"}}),_c('div',{staticStyle:{"height":"50px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }